import { AutogenModelBrokerageWorkflow, AutogenRowBrokerageWorkflow } from "./autogen/AutogenModelBrokerageWorkflow";

export class ModelBrokerageWorkflow extends AutogenModelBrokerageWorkflow<RowBrokerageWorkflow> {
    constructor() {
        super(RowBrokerageWorkflow);
    }
}

export class RowBrokerageWorkflow extends AutogenRowBrokerageWorkflow {
}